import React from 'react'

import "./marketing.css"


//import MarketingContext from '../../../contexts/MarketingContext'

import { Roulette } from './Roulette'
import { TestsStats } from './TestsStats'


export const Marketing = () => {
    
   
  return (

    <div className="homeContainer">
       
        <Roulette />

        <TestsStats />
       
     </div>
  )
}


